import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Cancel from "@material-ui/icons/CancelOutlined";
import ReactHtmlParser from 'react-html-parser';

const styles = theme => ({
  dialogRoot:{
    cursor:"pointer",
    userSelect:"none"
  },
  dialogContainer: {
    borderRadius: "2px",
    background: theme.ModalBGColor,
    overflow: "visible"
  },
  dialogTitle: {
    padding: 0
  },
  dialogContent: {
    fontSize: "14px",
    fontWeight: "bold",
    lineHeight: "19px",
    padding: "30px 50px",
    textAlign: "justify",
    color: theme.gridTextColor,
    '& b':{
      color: theme.HeaderSelectedText
    }
  },
  supportLink: {
    color: theme.HeaderSelectedText,
    fontSize: "16px",
    textAlign: "center",
    textDecoration: "underline",
    lineHeight: "22px",
    paddingTop: "20px",
    cursor: "pointer"
  },
  time: {
    color: theme.HeaderSelectedText
  },
  closeIcon:{
    fontSize:24,
    position:"absolute",
    right:-12,
    top:-12,
    backgroundColor: theme.ModalBGColor,
    color: theme.HeaderSelectedText,
    borderRadius:"50%"
  },
  messageContent:{
    overflowY:"auto",
    maxHeight:250,
    padding:"0px 10px"
  }
});

const RMAXMaintenance = (props)  => {


  function contactSupport(){
    const iframe = document.getElementById("launcher-frame");
    if(iframe){
      const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
      const freshdeskClickable = innerDoc ? innerDoc.querySelector('[data-testid="launcher-wrapper"]') : null;
      freshdeskClickable && freshdeskClickable.click && freshdeskClickable.click();
    }
 
  };

  
   const { classes, isClosable, message } = props;
   const htmlString = ReactHtmlParser(message);
   return (
      <Dialog open={true} classes={{ paper: classes.dialogContainer , root: classes.dialogRoot}} className={`dialog ${props.themeName || "dark"}theme`}>
        <DialogTitle
          disableTypography={true}
          classes={{ root: classes.dialogTitle }}
        >
          { isClosable ? <Cancel classes={{root: classes.closeIcon }}onClick={props.onClose} /> : null}        
          <div>
            <img
              src="../../../../images/RMAXMaintenance.png"
              alt="RMAX Maintenance"
              width="600"
              height="383"
            />             
          </div> 
          
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <div className={`${classes.messageContent} customScroll`}>
            {/* <p>
              RouteMAX will be undergoing scheduled maintenance at 
              <span className={classes.time}> {time} EST</span>.  We expect it to
              take about {duration} hour(s). 
            </p> */}
            {/* <p>
              Your work will not be synced at this time. We encourage you to log
              back in after an hour and continue your work.
            </p>
            <p>
              We hope this will not be too much of a disruption and appreciate
              your understanding. If you have other questions or concerns,
              please click on the below button to contact us.
            </p> */}
            { htmlString }
          </div>
          <div className={classes.supportLink} onClick={contactSupport}>
            Contact Support
          </div>
        </DialogContent>
      </Dialog>
    )
}

export default withStyles(styles)(RMAXMaintenance);

